module.exports = global["MobileDetect"] = require("-!/Users/gilbarbara/Sites/react-redux-starter/node_modules/mobile-detect/mobile-detect.js");


/*****************
 ** WEBPACK FOOTER
 ** ../~/expose-loader?MobileDetect!../~/mobile-detect/mobile-detect.js
 ** module id = 226
 ** module chunks = 1
 **/